import type { AirSection } from "@weather-deck/shared";
import { el } from "./dom";

const EU_LIMITS = { pm25: 25, pm10: 40, no2: 40, o3: 120 };

function fmt(n: number | null | undefined): string {
  return n == null ? "—" : n.toFixed(0);
}

function pollutant(label: string, value: number | null | undefined): HTMLElement {
  return el("span", {}, [
    document.createTextNode(`${label} `),
    el("strong", { text: fmt(value) })
  ]);
}

export function buildAirQuality(air: AirSection): HTMLElement {
  if (!air) {
    return el("section", { className: "aq" }, [
      el("h3", { text: "Air Quality" }),
      el("p", { text: "unavailable" })
    ]);
  }
  const airObj = air as unknown as { pollutants?: { pm25?: number; pm10?: number; no2?: number; o3?: number }; measurements?: { pm25?: number; pm10?: number; no2?: number; o3?: number } };
  const m = airObj.pollutants ?? airObj.measurements ?? { pm25: null, pm10: null, no2: null, o3: null };

  return el("section", { className: "aq" }, [
    el("h3", { text: `Air Quality · ${air.stationName}` }),
    el("div", { className: "pollutants" }, [
      pollutant("PM2.5", m.pm25),
      pollutant("PM10",  m.pm10),
      pollutant("NO₂",   m.no2),
      pollutant("O₃",    m.o3)
    ]),
    el("p", { className: "limits",
      text: `EU limit: PM2.5 ${EU_LIMITS.pm25} · PM10 ${EU_LIMITS.pm10} · NO₂ ${EU_LIMITS.no2} · O₃ ${EU_LIMITS.o3} (µg/m³)` })
  ]);
}
